import { Switch } from "@/common/ui/switch";

export interface BooleanControlProps {
  readonly capabilityId: string;
  readonly value: boolean;
  readonly onChange: (value: boolean) => void;
  readonly disabled?: boolean;
}

export function BooleanControl({
  capabilityId,
  value,
  onChange,
  disabled = false,
}: BooleanControlProps): JSX.Element {
  return (
    <Switch
      id={`${capabilityId}-boolean`}
      data-testid="entitlement-control-boolean"
      aria-label={capabilityId}
      checked={value}
      disabled={disabled}
      onCheckedChange={onChange}
    />
  );
}
